import { useCallback } from "react";
import { Token } from "../store/global/TokenEnum";
import { useTokenListByChain } from "./useTokenListByChain";
import { getTokenDecimals } from "../utils/tokenUtils";

export const useGetTokenDecimals = () => {
  const tokenList = useTokenListByChain();
  return useCallback((symbol: Token) => getTokenDecimals(symbol, tokenList), [tokenList]);
};
